/**
 * Which requests belong to course-finder-be, and nothing else.
 *
 * The console already attaches its session token to every `HttpClient` request
 * (`auth.interceptor.ts`), and that token is exactly what course-finder-be wants
 * — it verifies Crizac's own JWTAPIKEY / AGENTJWTAPIKEY. So nothing here has to
 * add a header. What this predicate is for is the OTHER half of that
 * interceptor: the 401 handler, which must not treat a refusal from a different
 * service as the console's own session expiring.
 *
 * Matched on the PATH, because `courseFinderApiUrl` is empty in every
 * environment (same-origin, resolved by `proxy.conf.ts` in dev and the reverse
 * proxy in production) but may be an absolute host on a deployment that cannot
 * proxy. Both spellings have to match the same rule.
 *
 * The console's own auth routes are `/v1/api/auth/...` and `/v2/api/auth/...`,
 * so the version prefix is what keeps them apart from course-finder-be's bare
 * `/api/auth/whoami`. That check comes first so the rule cannot later be
 * widened into swallowing the console's login.
 */
const COURSE_FINDER_PATH = /(?:^|\/)api\/(programs|courses|universities|auth|application-tat|application-search|user-mail-activity|university-mailboxes)(\/|$)/;

export function isCourseFinderRequest(url: string): boolean {
  if (!url) return false;
  if (/\/v\d+\/api\//.test(url)) return false;
  return COURSE_FINDER_PATH.test(url);
}
